<!-- <div class="sidebar border"  >
    <div class="clear10"></div>
    <div class="menu outline-0 cp" routerLink="/dashboard"><img src="./assets/images/inner-logo.png" /></div>
    <div class="clear40"></div>
    <a class="fs-16 mr-3"routerLink="/dashboard/dashboard-mga"><img src="./assets/images/dashboard.png"class="fs-18 mr-3"/>Dashboard</a>
 </div> -->

 <div class="col-12 col-sm-12 col-md-12 col-lg-12 boxstyle">
    <div class="row whitebox">
        <div class="col-sm-8 col-md-8 col-lg-8 col-12">
            <span class="cp olnone fs-16 semi-bold text46" routerLink="/dashboard/dashboard-mga" rout>Leads &nbsp;&nbsp; <img src="./assets/images/unnext.png"> </span>
            <span class="fs-16 semi-bold text46 ml-3">&nbsp;&nbsp;{{firstName}} {{lastName}}</span>
            <span class="fs-16 semi-bold text46 ml-3" *ngIf="leadStatusStage == 'Deactivated'">&nbsp;&nbsp;({{leadStatusStage}})</span>
        </div>
        <div class="col-sm-4 col-md-4 col-lg-4 col-12 text-right">
            <label class="m-0 cp mr-2" (click)="previousClickLeads(Id)"><img  class="mr-1" src="./assets/images/unback.png">Prev</label>
            <label class="m-0 cp ml-2" (click)="nextClickLeads(Id)">Next<img  class="ml-1" src="./assets/images/unnext.png"></label>
        <!-- </div> -->
    <!-- <div class="col-sm-3 col-md-3 col-lg-3 col-12 agentcodeDropdown text-right"> -->
        <label [hidden]="showAgentCodeButton==false || leadStatusStage !== 'Activated'" class="semi-bold agentcode-style cp text-left ml-1" [ngClass]="{'activeagentcode-style': showDropDown1}" (mouseclick)="openDropDown($event)"
       
        (mouseclick)="closeDropDown($event)" (click)="openDropDown1($event)"><span class="fs-15  mt-1 ">{{primaryAgentCodeShow}}</span></label>
        
            <div class="float-right" *ngIf="showDropDown">
                <!-- <div  class="headerlabelbox" style="right:351px;"  *ngFor="let item of getAgentCodeDetails;let i=index;" >
                    <label class="tooltip1 mr-1 ">
                        
                        <span class="fs-15  mt-1 " *ngFor="let item of getAgentCodeDetails;let isLast=last"><br>{{item.agentCode}}-{{item.status}}</span>
                    </label>
                  </div> -->
            </div>
            <label class="float-right absolute" *ngIf="showDropDown1" >
                <div class="headerlabelbox">
                    <div class="row" *ngFor="let item of getAgentCodeDetails;let isLast=last">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 fs-15 text-left">{{item.agentCode}}</div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 fs-15">{{item.agentUserId}}</div>
                    </div>
                    <!-- <label class="tooltip1 mr-1 ">
                        <span class="fs-15 " *ngFor="let item of getAgentCodeDetails;let isLast=last"><br>{{item.agentCode}}-{{item.status}}</span>
                    </label> -->
                </div>
            </label>
    </div>
    </div>
    
    <div class="clear10"></div>
    <div class="tab">
        <div class="row">
            <div class="col-sm-3 col-md-3 col-lg-3 col-12 pt-2 cp">
                <div class="card card-box tablinks  {{tabs[0].active}}" (click)="openTabs(0)">
                    <div class="card-body">
                        <div class="row">
                            <!-- <img src="./assets/images/redcircle.png" class="redcircle" *ngIf="hidecircle0" /> -->
                            <div class="col-sm-4 col-md-4 col-lg-4 col-12">
                                <img src="./assets/images/pinfo-box.png">
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-12 mt-1">
                                <h6 class="semi-bold txt-black1 mt-2">Personal Info</h6>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <!-- <button type="button" class="btn btn-gn">COMPLETED</button> -->
                        <button *ngIf="isPersonalInfo==true" type="button" class="btn btn-gn">COMPLETED</button>
                        <!-- <button *ngIf="incompleted1 === true" type="button" class="btn btn-yellow">IN-PROGRESS</button> -->
                        <button *ngIf="incompletedpi == true" type="button" class="btn btn-yellow">IN-PROGRESS</button>
                        <button *ngIf="isPending1==true" type="button" class="btn btn-pink">PENDING</button>
                        <div class="clear5"></div>
                        <p class="fs-12 regular">{{personalDate}} by {{personalName}}</p>
                    </div>
                </div>


            </div>
            <div class="col-sm-3 col-md-3 col-lg-3 col-12 pt-2 cp">

                <div class="card card-box tablinks {{tabs[1].active}}" (click)="openTabs(1)">

                    <div class="card-body">

                        <div class="row">
                            <!-- <img src="./assets/images/redcircle.png" class="redcircle" *ngIf="hidecircle1" /> -->
                            <div class="col-sm-4 col-md-4 col-lg-4 col-12">
                                <img src="./assets/images/docx-box.png">
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-12 mt-1">
                                <h6 class="semi-bold txt-black1 mt-2 nowrap">Upload Documents</h6>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <!-- <button type="button" class="btn btn-gn">COMPLETED</button> -->
                        <!-- <button *ngIf="isDocumentApproved == false" type="button" class="btn btn-gn">COMPLETED</button>
                        <button *ngIf="isDocumentApproved == true" type="button" class="btn btn-pink">PENDING</button> -->
                        <button *ngIf="isUploadDocument==true" type="button" class="btn btn-gn">COMPLETED</button>
                        <button *ngIf="incompleted1 === true" type="button" class="btn btn-yellow">IN-PROGRESS</button>
                        <button *ngIf="isPendingDoc==true" type="button" class="btn btn-pink">PENDING</button>
                        <div class="clear5"></div>
                        <p class="fs-12 regular">{{uploadDate}} by {{uploadName}}</p>
                    </div>
                </div>

            </div>
            <div class="col-sm-3 col-md-3 col-lg-3 col-12 pt-2 cp">
                <div class="card card-box tablinks {{tabs[2].active}}" (click)="openTabs(2)">
                    <div class="card-body">
                        <div class="row">
                            <!-- <img src="./assets/images/redcircle.png" class="redcircle" *ngIf="hidecircle2" /> -->
                            <div class="col-sm-4 col-md-4 col-lg-4 col-12">
                                <img src="./assets/images/sign-box.png">
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-12 mt-1">
                                <h6 class="semi-bold txt-black1 mt-2">Sign Agreement</h6>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <!-- <button type="button" class="btn btn-orange">IN-PROGRESS</button> -->
                        <!-- <button *ngIf="isDocumentApproved2 == false" type="button" class="btn btn-gn">COMPLETED</button>
                        <button *ngIf="isDocumentApproved2 == true" type="button" class="btn btn-pink">PENDING</button> -->
                        <button *ngIf="isSignAgreement==true" type="button" class="btn btn-gn">COMPLETED</button>
                        <button *ngIf="isPendingContract==true" type="button" class="btn btn-pink">PENDING</button>
                        <button *ngIf="isInprogressContract==true" type="button" class="btn btn-yellow">IN-PROGRESS</button>
                        <div class="clear5"></div>
                        <p class="fs-12 regular">{{signedDate}} by {{signedName}}</p>
                    </div>
                </div>

            </div>
            <div class="col-sm-3 col-md-3 col-lg-3 col-12 tablinks pt-2 cp">
                <!-- <div class="card card-box {{tabs[3].active}}" (click)="openTabs(3)"> -->
                <div class="card card-box">
                    <div class="card-body">
                        <div class="row">
                            <!-- <img src="./assets/images/redcircle.png" class="redcircle" *ngIf="hidecircle3" /> -->
                            <div class="col-sm-4 col-md-4 col-lg-4 col-12">
                                <img src="./assets/images/training-box.png">
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-12 mt-1">
                                <h6 class="semi-bold txt-black1 mt-2">Online Training</h6>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <!-- <button *ngIf="isDocumentApproved3 == false" type="button" class="btn btn-gn">COMPLETED</button>
                        <button *ngIf="isDocumentApproved3 == true" type="button" class="btn btn-pink">PENDING</button> -->
                        <!-- <button *ngIf="isOnlineTraining==true" type="button" class="btn btn-gn">COMPLETED</button> -->
                        <!-- <button *ngIf="isInprogressTraining==true" type="button" class="btn btn-yellow">IN-PROGRESS</button> -->
                        <button *ngIf="isOnlineTraining==true" type="button" class="btn btn-gn">COMPLETED</button>
                        <button *ngIf="isPendingTraining==true" type="button" class="btn btn-pink">PENDING</button>
                        <button *ngIf="isInprogressTraining==true" type="button" class="btn btn-yellow">IN-PROGRESS</button>
                        <div class="clear5"></div>
                        <p class="fs-12 regular">{{onlinetDate}} by {{onlinetName}}</p>
                    </div>
                </div>
                <div class="clear10"></div>
            </div>
        </div>
        <hr class="ml-1" />
    </div>

    <div class="ml-1">
        <div class="{{tabs[0].tabcontent}}" *ngIf="tabs[0].active">
            <div class="row greystrip">
                <div class="col-sm-8 col-md-8 col-lg-8 col-12">
                    <h5 class="semi-bold text46 pl-2 mt-1">Personal Info</h5>
                </div>
                <!-- <div class="col-sm-4 col-md-3 col-lg-3 col-12 ml-auto">
                    <button type="button" class="btn btn-blue" *ngIf="showEdit" (click)="Edit()">Edit</button>
                    <button type="button" class="btn btn-dblue ml-3" *ngIf="showSave == true" (click)="editLeads()"> Update</button>
                    <button type="button" class="btn cancalbtn" *ngIf="showSave" (click)="this.deleteLeadsPopup = !this.deleteLeadsPopup">Cancel</button>

                </div> -->
            </div>
            <div class="row pad10 topinfo">
                <div class="col-3 col-sm-1 col-md-1 col-lg-2">
                    <label class="regular fs-15 text-center">Salutation</label>
                    <label class="fbold bold  fs-15 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">{{salutation}}</label>
                </div>
                <div class="col-3 col-sm-3 col-md-3 col-lg-2">
                    <label class="regular fs-15 text-center">First Name</label>
                    <label class="fbold bold  fs-15 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">{{firstName}}</label>
                </div>
                <div class="col-3 col-sm-3 col-md-3 col-lg-2">
                    <label class="regular fs-15 text-center">Middle Name</label>
                    <label class="fbold bold fs-15 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">{{middleName}}</label>
                </div>
                <div class="col-3 col-sm-3 col-md-3 col-lg-2">
                    <label class="regular fs-15 text-center">Last Name</label>
                    <label class="fbold bold  fs-15 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">{{lastName}}</label>
                </div>
                <div class="col-3 col-sm-3 col-md-3 col-lg-4">
                    <label class="regular fs-15 text-center">Email Address</label>
                    <label class="fbold bold fs-15 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12"><a href="mailto:join@travelance.ca">{{primaryEmailAddress}}</a></label>
                </div>
                <div class="clear20"></div>
            </div>
            <div>
                <div>
                    <ul>
                        <li class="semi-bold {{tabs1[0].active1}}" (click)="openTabs1(0)"><a class="active">Business Card</a></li>
                        <li class="semi-bold {{tabs1[1].active1}}" (click)="openTabs1(1)"><a>Compliance</a></li>
                        <!-- <li class="semi-bold {{tabs1[2].active1}}" (click)="openTabs1(2)"><a>Marketing</a></li> -->
                    </ul>
                </div>
                <div class="clear20"></div>
                <div class="{{tabs1[0].tabcontent1}}" *ngIf="tabs1[0].active1">
                    <!-- <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Date Created:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{dateCreated}} by {{Createdbyname}}</p>
                                </div>
                            </div>

                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Date Modified:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular"> {{dateModified}} by {{modifiedbyname}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Sign-up Status:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{leadStatusStage}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Agency Code:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{agencyCodeAgent}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Agent Nurture Status:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{agentNurture}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right"></label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Type:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{type}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Policy Count:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Assigned To:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{assignedToFirstname}}{{assignedToLastname}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Count Training:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{countTrainig}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Commission To:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{commitionTo}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Company Name:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{companyName}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Position Title:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{positionTitle}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 " *ngIf="isCompanyRegister">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Company Name:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{companyName}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 " *ngIf="isCompanyRegister==false">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Agency Name:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{showAgencyName}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Work Phone:</label>
                                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                    <p class="fs-15 regular">{{workPhone}}</p>
                                </div>
                                <label class="mb-2 mr-1 semi-bold fs-15 txt-lightblack2 ml-2"> Ext</label>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                    <!-- <input type="text" [(ngModel)]="workPhoneExt" class="form-control forminput Tab " style="width: 100px;" placeholder="Extentions"> -->
                                    <p class="fs-15 regular" style="width: 100px;">{{workPhoneExtension}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">MGA Name:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular">{{mgaName}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Mobile Number:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{mobile}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Agent Nurture Status:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{agentNurtureStatus}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Competitor Products:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{productsSelling}}</p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Other Phone:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{phoneOther}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Last Training Date:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{lastTrainingDate}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Address Street:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{primaryAddressLine}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Proficient Languages:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{langauges}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">City:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{primaryAddressCity}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Lead Source Other:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Province:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{primaryAddressProvince}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <!-- <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Fax:</label> -->
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <!-- <p class="fs-15 regular">{{fax}}</p> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Postal Code:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{primaryAddressPostalCode}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Alt Address Street:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular">{{alternativeAddressLine}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Website:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular"><a href="https://{{website}}" target="_blank"></a>{{website}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Alt Address City:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular">{{alternativeAddressCity}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">B2C Link Request:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <p class="fs-15 regular">{{myTravelLinkRequest}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Alt Address Province:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular">{{alternativeAddressProvince}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                        <div class="form-row">
                            <label class="mb-2 mr-3 regular fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Wish to add an Alternative Address? &nbsp;&nbsp;:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular">Yes</p>
                                </div>
                        </div>
                    </div> -->


                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">B2C Link:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                    <!-- <p class="fs-15 regular">{{languages1}}</p> -->
                                    <p class="fs-15 regular">{{myTravelLink}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Alt Address Postal Code:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular">{{alternativeAddressPostalCode}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right"></label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Tags:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular">{{tags}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">User ID:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{userId}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Password:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular">{{passwordAgenctCode}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="{{tabs1[1].tabcontent1}}" *ngIf="tabs1[1].active1">
                    <!-- <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Lead Status:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1">{{leadStatus}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" *ngIf="leadStatus=='DNC'">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">DNC Status:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{dncStatusval}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">License Type:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1">{{licencesTypes}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <!-- <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Agency Code:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1">{{agencyCode}}</p>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Provinces Licensed:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1" *ngFor="let item of PLicensedArray">{{item.itemName}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                         
                            <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">My Travel Link Request:</label>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                <p class="fs-15 regular mt-1">{{MyTravelLinkRequest}}</p>
                            </div>
                        </div> -->
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">My Travel Link Request:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1">{{MyTravelLinkRequest}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">

                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Password:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{password}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">E&O:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1">{{EOLicenseNo}}</p>
                                </div>
                            </div>

                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">E&O Expiration Date:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate | date: 'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Resident Province:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1">{{residentLicense1}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Resident License Expiry Date:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                                    <p class="fs-15 regular mt-1">{{ResidentLicenseExpiryDate | date: 'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 1:</label>
                                <ng-select disabled class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab" [(ngModel)]="primaryAddressProvince1">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option *ngFor="let item of provinceArray" [value]="item.id">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 1:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate1 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 2:</label>
                                <ng-select disabled class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab" [(ngModel)]="primaryAddressProvince2">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option *ngFor="let item of provinceArray" [value]="item.id">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 2:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate2 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 3:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince3" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 3:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate3 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 4:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince4" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 4:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate4 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 5:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince5" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 5:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate5 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 6:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince6" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 6:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate6 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 7:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince7" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 7:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate7 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 8:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince8" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 8:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate8 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 9:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince9" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 9:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate9 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 10:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince10" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 10:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate10 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 11:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince11" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 11:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate11 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Province 12:</label>
                                <ng-select disabled [(ngModel)]="primaryAddressProvince12" class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <!-- <option disabled>Select</option> -->
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <ng-option [value]="item.id" *ngFor="let item of provinceArray">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">Non Resident Expiry Date 12:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{EOexpiryDate12 | date:'MM/dd/yyyy'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <div class="form-row">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 mt-1 semi-bold fs-15 txt-lightblack2 text-right">CIPR Number:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular mt-1">{{ciprNumber}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="{{tabs1[2].tabcontent1}}" *ngIf="tabs1[2].active1">
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">My Travel Link:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{myTravelLink}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Website:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular"><a href="https://{{website}}" target="_blank"></a>{{website}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Special Bonus:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{specialBonus}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                         
                        </div>
                    </div>
                    <div class="row rowcolorgrey">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Other:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{jumpStart}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            
                        </div>
                    </div>
                    <div class="row rowcolorWhite">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">My Travel Link:</label>
                                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 ">
                                    <p class="fs-15 regular">{{myTravelLink}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 ">
                            <div class="form-row">
                                <label class="mb-2 mr-3 semi-bold fs-15 txt-lightblack2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">Website:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    <p class="fs-15 regular"><a href="https://{{website}}" target="_blank"></a>{{website}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 rowcolorWhite">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">CASL Opt Out:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular">{{caslOptOut}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 rowcolorgrey">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Consent Date:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular">{{consentDate}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 rowcolorWhite">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Consent Status:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular">{{consentStatus}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 rowcolorgrey">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Jump Start:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular">{{jumpStart}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 rowcolorWhite">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Special Bonus:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular">{{specialBonus}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 rowcolorgrey">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Other:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                        </div>
                        <div class="clear20"></div>
                        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 rowcolorWhite">
                            <div class="form-row">
                                <label class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">My Travel Link:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 Tab">
                                    <p class="fs-15 regular">{{myTravelLink}}</p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12">
                            <div class="form-row rowcolorWhite">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Proof of Consent:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-0 Tab ">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="form-row rowcolorgrey">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Admin Only:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-0 Tab ">
                                    <p class="fs-15 regular">{{adminOnly}}</p>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="form-row rowcolorgrey">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right">Website:</label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-0 Tab ">
                                    <p class="fs-15 regular">
                                        <a href="https://{{website}}" target="_blank"></a>{{website}}</p>
                                </div>
                            </div>
                            <div class="form-row rowcolorWhite" style="height: 41px;">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right"></label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-0 Tab ">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="form-row rowcolorgrey" style="height: 40px;">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right"></label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-0 Tab ">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="form-row rowcolorWhite" style="height: 40px;">
                                <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 semi-bold fs-15 txt-lightblack2 text-right"></label>
                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-0 Tab ">
                                    <p class="fs-15 regular"></p>
                                </div>
                            </div>
                            <div class="clear20"></div>
                        </div>
                        <div class="clear20"></div>
                    </div> -->
                </div>
            </div>

        </div>
        <div class="{{tabs[1].tabcontent}}" *ngIf="tabs[1].active">
            <div>
                <ul class="changes">
                    <li class="semi-bold {{tabs2[0].active2}}" (click)="openTabs2(0);getDocument()"><a class="active">Individual</a></li>
                    <!-- <li *ngIf="showAgency" class="semi-bold {{tabs2[1].active2}}" (click)="openTabs2(1);getLeadSDocumentAgency()"><a>Company</a></li> -->
                    <ng-container *ngFor="let itemLinkAgency of brokerLinkMGAAgency; let m = index">
                        <li *ngIf="itemLinkAgency.isCompnaySignUp && showAgency" class="semi-bold {{tabs22[m].active22}}" title="{{itemLinkAgency.agencyName}}">
                          <a (click)="openTabs22(m); getLeadSDocumentAgency(itemLinkAgency.agencyId,m)">
                            {{itemLinkAgency.agencyName}}
                          </a>                             
                        </li>
                      </ng-container>
                    <ng-container *ngFor="let itemLinkMGA of brokerLinkMGA; let j=index">
                        <li *ngIf="type == 'MGA Rep'" class="semi-bold {{tabs21[j].active21}}" title="{{itemLinkMGA.mgaName}}">
                          <a (click)="openTabs21(j);callMgaDoc(itemLinkMGA.mgaId,j)">{{itemLinkMGA.mgaName}}</a>
                        </li>
                      </ng-container>
                </ul>
                <input type="text" *ngIf="editMGAShortName" class=" mgaNameMargin " [ngClass]="{'mgaNameMargin':showAgency==false ,'mgaNameMargincompany':showAgency==true}" placeholder="MGA Name"  [(ngModel)]="mgaName" (blur)="updateMgaShortName()">
            </div>
            <div class="{{tabs2[0].tabcontent2}}" *ngIf="tabs2[0].active2">
                <div class="clear20"></div>
                <label class="fbold fs-18 txt39">E & O</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>



                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <!-- <th class="semi-bold fs-14 text46">Document type</th> -->
                                <th class="semi-bold fs-14 text46 w150">E&O Policy Number</th>
                                <th class="semi-bold fs-14 text46 w150">Uploaded Date</th>
                                <th class="semi-bold fs-14 text46 w150">Effective Date</th>
                                <th class="semi-bold fs-14 text46 w150">Expiry Date</th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                <th class="semi-bold fs-14 text46 w150">Status</th>
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>
                                <!-- <th></th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getDocuments; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel">{{item.documentName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.documentName}}</label>
                                    <!-- <button type="button" class="fs-12 mr-2  btn bluebtn float-left" (click)="downloadEODocuments(getDocuments[i].fileDownloadUrl, getDocuments[i].documentName)"></button> -->

                                </td>
                                <!-- <td class="fs-14 regular dgrey">{{item.type}}</td> -->
                                <td class="fs-14 regular dgrey">{{item.policyNumber!=null?item.policyNumber:'-'}}</td>
                                <td class="fs-14 regular dgrey">{{item.updatedAt | date:'MM-dd-yyyy'}}</td>
                                 <td class="fs-14 regular dgrey">{{item.effectiveDate | date:'MM/dd/yyyy'}}</td>
                                <td class="fs-14 regular dgrey"  [ngClass]="{'expiring': item.isExpiring==true,'expired': item.isExpired==true}">{{item.expiryDate | date:'MM/dd/yyyy'}}</td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue" ><u class="cp" (click)="this.pdfmodel = !this.pdfmodel; onSelected(item.documentName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fbold fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                    <div class="row" *ngIf="item.status == 'Not Approved' || item.status == ''|| item.status == 'More Information Required'">
                                        <h3 class="fs-14 red regular">Action:'{{item.description}}'</h3>
                                    </div>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)=" this.uploadExpEOPopup = !this.uploadExpEOPopup;OverwriteEODoc(item)" title="Update" src="./assets/images/update.png"></label></td>
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                               -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                               -->
                                <!-- <td></td> -->
                            </tr>
                            <tr>
                                <td class="fs-14 regular dorange" *ngIf="getDocuments.length ==0">No Document available</td>
                                <td class="fs-14 regular dblue nowrap" *ngIf="getDocuments.length ==0"><u (click)=" this.uploadExpEOPopup = !this.uploadExpEOPopup;addEoStatus()" class="cp link">Add E & O</u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">10/09/2020</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen" ><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                              
                         
                        </tr>  -->

                        </tbody>
                    </table>
                </div>
                <div class="clear10"></div>
                <label class="fbold fs-18 txt39">License</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>
                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <th class="semi-bold fs-14 text46 w150">License Type</th>
                                <th class="semi-bold fs-14 text46 w150">Province</th>
                                <th class="semi-bold fs-14 text46 w150">License Number</th>
                                <th class="semi-bold fs-14 text46 w150">Effective Date</th>
                                <th class="semi-bold fs-14 text46 w150">Expiry Date</th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                <th class="semi-bold fs-14 text46">Status</th>
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>
                                <!-- <th></th>     -->
                                <!-- <th></th>             -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getLicences; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel1 = !this.pdfmodel1; ">{{item.licenseName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.licenseName}}</label>
                                </td>
                                <td class="fs-14 regular dgrey">{{item.type}}</td>
                                <td class="fs-14 regular dgrey">{{item.provinces.provinceName}}-{{item.provinces.provinceCode}}</td>
                                <td class="fs-14 regular dgrey">{{item.licensesNumber}}</td>
                                <td class="fs-14 regular dgrey">{{item.effectiveDate | date:'MM/dd/yyyy'}}</td>
                                <td class="fs-14 regular dgrey" [ngClass]="{'expiring': item.isExpiring==true,'expired': item.isExpired==true}">{{item.expiryDate | date:'MM/dd/yyyy'}}</td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue "><u class="cp" (click)=" this.pdfmodel1 = !this.pdfmodel1; onSelected(item.licenseName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                    <div class="row" *ngIf="item.status == 'Not Approved' || item.status == ''|| item.status == 'More Information Required'">
                                        <h3 class="fs-14 red regular">Action:'{{item.description}}'</h3>
                                    </div>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)=" this.uploadnewLicensePopup = !this.uploadnewLicensePopup;OverwriteLic(item,i)" title="Update" src="./assets/images/update.png"></label></td>
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;" >More Info Req</u></td>                                 -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                                 -->
                            </tr>
                            <tr>
                                <td class="fs-14 regular dorange">{{getLicences.length}} License(s) uploaded</td>
                                <td class="fs-14 regular dblue nowrap"><u (click)=" this.uploadnewLicensePopup = !this.uploadnewLicensePopup;openAddLicPopup()" class="cp link">Add License
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">To add a new license, click "Add License" and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">Type</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen "><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                                
                            <td></td>
                        </tr> 
                        <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">Type</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtred"><u>Disapprove</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                                
                            <td></td>
                        </tr>  -->


                        </tbody>
                    </table>
                </div>

                <div class="clear10" [hidden]=" commitionTo != 'Broker' || showAgency"></div>
                <label class="fbold fs-18 txt39" [hidden]=" commitionTo != 'Broker' || showAgency">Void Cheque</label>
                <div class="table-responsive" [hidden]=" commitionTo != 'Broker' || showAgency">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>



                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <th class="semi-bold fs-14 text46 w150">Status</th>
                                <!-- <th class="semi-bold fs-14 text46">Document type</th> -->
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 ">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>
                                <th class="semi-bold fs-14 text46 w150"></th>
                                <th class="semi-bold fs-14 text46 w150"></th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                
                                <!-- <th></th>  -->
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getVoidCheck; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel">{{item.documentName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <!-- <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.documentName}}</label> -->
                                    <label class="lightblue fs-14 regular cp" (click)="onClickOTPValidation(item)">{{item.documentName}}</label>
                                    <!-- <button type="button" class="fs-12 mr-2  btn bluebtn float-left" (click)="downloadEODocuments(getDocuments[i].fileDownloadUrl, getDocuments[i].documentName)"></button> -->

                                </td>
                                <!-- <td class="fs-14 regular dgrey">{{item.type}}</td> -->
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)="onClickOTPValidation1(item);overwriteVoid(item);uploadEno1Void(item,i);bankInfoPop('Confirm'); removeFields();" title="Update" src="./assets/images/update.png"></label></td>
                                <td>
                                    <!-- <button type="button" class="btn edit lightblue p-0" (click)="bankInfoPop();overwriteVoid(item);uploadEno1Void(item,i);"><u>Bank Information</u></button> -->
                                </td>
                                <td class="fs-14 regular dgrey"></td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue" ><u class="cp" (click)="this.pdfmodel = !this.pdfmodel; onSelected(item.documentName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                               -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                               -->
                                <td></td>
                            </tr>
                            <tr *ngIf="getVoidCheck.length==0">
                                <td class="fs-14 regular dorange">No Document available</td>
                                <td *ngIf="getVoidCheck.length<1" class="fs-14 regular dblue"><u class="cp link" (click)="addFieldValuecheque();  bankInfoPop('Save');this.uploadVoidChequePopup = !this.uploadVoidChequePopup">Add Void Cheque</u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">10/09/2020</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen" ><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                              
                         
                        </tr>  -->

                        </tbody>
                    </table>
                </div>
                <div class="clear10"></div>
                <label class="fbold fs-18 txt39">Miscellaneous</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead>
                            <tr>
    
    
    
                                <th class="semi-bold fs-14 text46">Document Name</th>
                                <th class="semi-bold fs-14 text46">Note</th>
                                <th class="semi-bold fs-14 text46">Type</th>
                                <!-- <th class="semi-bold fs-14 text46">Document type</th> -->
                                <th class="semi-bold fs-14 text46 w150"></th>
                                <th class="semi-bold fs-14 text46"></th>
                                <th class="semi-bold fs-14 text46 w150"></th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                
                                <!-- <th></th>  -->
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getMisc; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel">{{item.documentName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.documentName}}</label>
                                    <!-- <button type="button" class="fs-12 mr-2  btn bluebtn float-left" (click)="downloadEODocuments(getDocuments[i].fileDownloadUrl, getDocuments[i].documentName)"></button> -->
    
                                </td>
                                <!-- <td class="fs-14 regular dgrey">{{item.type}}</td> -->
                                <td class="fs-14 regular dgrey">{{item.note}}</td>
                                <td class="fs-14 regular dgrey">{{item.type}}</td>
                                <td class="fs-14 regular dgrey"></td>
                                <td class="fs-14 regular dgrey"></td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue" ><u class="cp" (click)="this.pdfmodel = !this.pdfmodel; onSelected(item.documentName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                <td class="fs-14 regular dgrey"></td>
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                               -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                               -->
                                <td></td>
                            </tr>
    
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngFor="let itemLinkMGA of brokerLinkMGAAgency; let j=index">
                <div class="{{tabs22[j].tabcontent22}}" *ngIf="tabs22[j].active22">
                <div class="clear20"></div>
                <label class="fbold fs-18 txt39">E & O</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>



                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <!-- <th class="semi-bold fs-14 text46">Document type</th> -->
                                <th class="semi-bold fs-14 text46 w150">E&O Policy Number</th>
                                <th class="semi-bold fs-14 text46 w150">Uploaded Date</th>
                                <th class="semi-bold fs-14 text46 w150">Effective Date</th>
                                <th class="semi-bold fs-14 text46 w150">Expiry Date</th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                <th class="semi-bold fs-14 text46 w150">Status</th>
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>
                                <!-- <th></th>  -->
                                <!-- <th></th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getDocuments; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel">{{item.documentName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.documentName}}</label>
                                    <!-- <button type="button" class="fs-12 mr-2  btn bluebtn float-left" (click)="downloadEODocuments(getDocuments[i].fileDownloadUrl, getDocuments[i].documentName)"></button> -->

                                </td>
                                <!-- <td class="fs-14 regular dgrey">{{item.type}}</td> -->
                                <td class="fs-14 regular dgrey">{{item.policyNumber!=null?item.policyNumber:'-'}}</td>
                                <td class="fs-14 regular dgrey">{{item.updatedAt | date:'MM-dd-yyyy'}}</td>
                                <td class="fs-14 regular dgrey">{{item.effectiveDate | date:'MM/dd/yyyy'}}</td>
                                <td class="fs-14 regular dgrey"  [ngClass]="{'expiring': item.isExpiring==true,'expired': item.isExpired==true}">{{item.expiryDate | date:'MM/dd/yyyy'}}</td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue" ><u class="cp" (click)="this.pdfmodel = !this.pdfmodel; onSelected(item.documentName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                    <div class="row" *ngIf="item.status == 'Not Approved' || item.status == ''|| item.status == 'More Information Required'">
                                        <h3 class="fs-14 red regular">Action:'{{item.description}}'</h3>
                                    </div>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)=" this.uploadExpEOPopup = !this.uploadExpEOPopup;OverwriteEODocAgency(item)" title="Update" src="./assets/images/update.png"></label></td>
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                               -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                               -->
                                <!-- <td></td> -->
                            </tr>
                            <tr>
                                <td class="fs-14 regular dorange" *ngIf="getDocuments.length ==0">No Document available</td>
                                <td class="fs-14 regular dblue nowrap" *ngIf="getDocuments.length ==0"><u (click)=" this.uploadExpEOPopup = !this.uploadExpEOPopup;addEoStatusAgency()" class="cp link">Add E & O</u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">10/09/2020</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen" ><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                              
                         
                        </tr>  -->

                        </tbody>
                    </table>
                </div>
                <div class="clear10"></div>
                <label class="fbold fs-18 txt39">License</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>
                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <th class="semi-bold fs-14 text46 w150">License Type</th>
                                <th class="semi-bold fs-14 text46 w150">Province</th>
                                <th class="semi-bold fs-14 text46 w150">License Number</th>
                                <th class="semi-bold fs-14 text46 w150">Effective Date</th>
                                <th class="semi-bold fs-14 text46 w150">Expiry Date</th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                <th class="semi-bold fs-14 text46 w150">Status</th>
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 ">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>    
                                <!-- <th></th>             -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getLicences; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel1 = !this.pdfmodel1; ">{{item.licenseName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.licenseName}}</label>
                                </td>
                                <td class="fs-14 regular dgrey">{{item.type}}</td>
                                <td class="fs-14 regular dgrey">{{item.provinces.provinceName}}-{{item.provinces.provinceCode}}</td>
                                <td class="fs-14 regular dgrey">{{item.licensesNumber}}</td>
                                <td class="fs-14 regular dgrey">{{item.effectiveDate | date:'MM/dd/yyyy'}}</td>
                                <td class="fs-14 regular dgrey"  [ngClass]="{'expiring': item.isExpiring==true,'expired': item.isExpired==true}">{{item.expiryDate | date:'MM/dd/yyyy'}}</td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue "><u class="cp" (click)=" this.pdfmodel1 = !this.pdfmodel1; onSelected(item.licenseName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                    <div class="row" *ngIf="item.status == 'Not Approved' || item.status == ''|| item.status == 'More Information Required'">
                                        <h3 class="fs-14 red regular">Action:'{{item.description}}'</h3>
                                    </div>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)=" this.uploadnewLicensePopup = !this.uploadnewLicensePopup;OverwriteLicAgency(item,i)" title="Update" src="./assets/images/update.png"></label></td>
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;" >More Info Req</u></td>                                 -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                                 -->
                            </tr>
                            <tr>
                                <td class="fs-14 regular dorange">{{getLicences.length}} License(s) uploaded</td>
                                <td class="fs-14 regular dblue nowrap"><u (click)=" this.uploadnewLicensePopup = !this.uploadnewLicensePopup;openAddLicPopupAgency()" class="cp link">Add License
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">To add a new license, click "Add License" and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">Type</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen "><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                                
                            <td></td>
                        </tr> 
                        <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">Type</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtred"><u>Disapprove</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                                
                            <td></td>
                        </tr>  -->


                        </tbody>
                    </table>
                </div>

                <div class="clear20"></div>
                <label class="fbold fs-18 txt39">Void Cheque</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>



                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <!-- <th class="semi-bold fs-14 text46">Document type</th> -->
                                <th class="semi-bold fs-14 text46 w150">Status</th>
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 ">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>
                                <th class="semi-bold fs-14 text46 w150"></th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                <th class="semi-bold fs-14 text46 w150"></th>
                                <!-- <th></th>  -->
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getVoidCheck; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel">{{item.documentName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <!-- <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.documentName}}</label> -->
                                    <label class="lightblue fs-14 regular cp" (click)="onClickOTPValidation(item)">{{item.documentName}}</label>
                                    <!-- <button type="button" class="fs-12 mr-2  btn bluebtn float-left" (click)="downloadEODocuments(getDocuments[i].fileDownloadUrl, getDocuments[i].documentName)"></button> -->

                                </td>
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)="onClickOTPValidation1(item);overwriteVoid(item);bankInfoPop('Confirm');uploadEno1Void(item,i);removeFields()" title="Update" src="./assets/images/update.png"></label></td>
                                <!-- <td class="fs-14 regular dgrey">{{item.type}}</td> -->
                                <td>
                                    <!-- <button type="button" class="btn edit lightblue p-0" (click)="bankInfoPop();overwriteVoid(item);uploadEno1Void(item,i);"><u>Bank Information</u></button> -->
                                </td>
                                <td class="fs-14 regular dgrey"></td>
                                <td class="fs-14 regular dgrey"></td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue" ><u class="cp" (click)="this.pdfmodel = !this.pdfmodel; onSelected(item.documentName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                               -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                               -->
                                <td></td>
                            </tr>
                            <tr *ngIf="getVoidCheck.length==0">
                                <td class="fs-14 regular dorange">No Document available</td>
                                <td *ngIf="getVoidCheck.length<1" class="fs-14 regular dblue"><u class="cp link" (click)=" addFieldValuecheque();bankInfoPop('Save');this.uploadVoidChequePopup = !this.uploadVoidChequePopup;">Add Void Cheque</u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">10/09/2020</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen" ><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                              
                         
                        </tr>  -->

                        </tbody>
                    </table>
                </div>
            </div>
            </div>
            <div *ngFor="let itemLinkMGA of brokerLinkMGA; let j=index">
                <div class="{{tabs21[j].tabcontent21}}" *ngIf="tabs21[j].active21">
                <div class="clear20"></div>
                <label class="fbold fs-18 txt39">E & O</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>



                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <!-- <th class="semi-bold fs-14 text46">Document type</th> -->
                                <th class="semi-bold fs-14 text46 w150">E&O Policy Number</th>
                                <th class="semi-bold fs-14 text46 w150">Uploaded Date</th>
                                <th class="semi-bold fs-14 text46 w150">Effective Date</th>
                                <th class="semi-bold fs-14 text46 w150">Expiry Date</th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                <th class="semi-bold fs-14 text46 w150">Status</th>
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>
                                <!-- <th></th>  -->
                                <!-- <th></th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getDocuments; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel">{{item.documentName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.documentName}}</label>
                                    <!-- <label class="lightblue fs-14 regular cp" (click)="onClickOTPValidation(item)">{{item.documentName}}</label> -->
                                    <!-- <button type="button" class="fs-12 mr-2  btn bluebtn float-left" (click)="downloadEODocuments(getDocuments[i].fileDownloadUrl, getDocuments[i].documentName)"></button> -->

                                </td>
                                <!-- <td class="fs-14 regular dgrey">{{item.type}}</td> -->
                                <td class="fs-14 regular dgrey">{{item.policyNumber!=null?item.policyNumber:'-'}}</td>
                                <td class="fs-14 regular dgrey">{{item.updatedAt | date:'MM-dd-yyyy'}}</td>
                                <td class="fs-14 regular dgrey">{{item.effectiveDate | date:'MM/dd/yyyy'}}</td>
                                <td class="fs-14 regular dgrey"  [ngClass]="{'expiring': item.isExpiring==true,'expired': item.isExpired==true}">{{item.expiryDate | date:'MM/dd/yyyy'}}</td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue" ><u class="cp" (click)="this.pdfmodel = !this.pdfmodel; onSelected(item.documentName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                    <div class="row" *ngIf="item.status == 'Not Approved' || item.status == ''|| item.status == 'More Information Required'">
                                        <h3 class="fs-14 red regular">Action:'{{item.description}}'</h3>
                                    </div>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)=" this.uploadExpEOPopup = !this.uploadExpEOPopup;OverwriteEODocAgency(item)" title="Update" src="./assets/images/update.png"></label></td>
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                               -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                               -->
                                <!-- <td></td> -->
                            </tr>
                            <tr>
                                <td class="fs-14 regular dorange" *ngIf="getDocuments.length ==0">No Document available</td>
                                <td class="fs-14 regular dblue nowrap" *ngIf="getDocuments.length ==0"><u (click)=" this.uploadExpEOPopup = !this.uploadExpEOPopup;" class="cp link">Add E & O</u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">10/09/2020</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen" ><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                              
                         
                        </tr>  -->

                        </tbody>
                    </table>
                </div>
                <div class="clear10"></div>
                <label class="fbold fs-18 txt39">License</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>
                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <th class="semi-bold fs-14 text46 w150">License Type</th>
                                <th class="semi-bold fs-14 text46 w150">Province</th>
                                <th class="semi-bold fs-14 text46 w150">License Number</th>
                                <th class="semi-bold fs-14 text46 w150">Effective Date</th>
                                <th class="semi-bold fs-14 text46 w150">Expiry Date</th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                <th class="semi-bold fs-14 text46 w150">Status</th>
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 ">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>    
                                <!-- <th></th>             -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getLicences; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel1 = !this.pdfmodel1; ">{{item.licenseName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <label class="lightblue fs-14 regular cp" (click)="onSelected(item.documentName,item.id,item.description,item.fileUrl,item.fileId)">{{item.licenseName}}</label>
                                </td>
                                <td class="fs-14 regular dgrey">{{item.type}}</td>
                                <td class="fs-14 regular dgrey">{{item.provinces.provinceName}}-{{item.provinces.provinceCode}}</td>
                                <td class="fs-14 regular dgrey">{{item.licensesNumber}}</td>
                                <td class="fs-14 regular dgrey">{{item.effectiveDate | date:'MM/dd/yyyy'}}</td>
                                <td class="fs-14 regular dgrey"  [ngClass]="{'expiring': item.isExpiring==true,'expired': item.isExpired==true}">{{item.expiryDate | date:'MM/dd/yyyy'}}</td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue "><u class="cp" (click)=" this.pdfmodel1 = !this.pdfmodel1; onSelected(item.licenseName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                    <div class="row" *ngIf="item.status == 'Not Approved' || item.status == ''|| item.status == 'More Information Required'">
                                        <h3 class="fs-14 red regular">Action:'{{item.description}}'</h3>
                                    </div>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)=" this.uploadnewLicensePopup = !this.uploadnewLicensePopup;OverwriteLicAgency(item,i)" title="Update" src="./assets/images/update.png"></label></td>
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;" >More Info Req</u></td>                                 -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                                 -->
                            </tr>
                            <tr>
                                <td class="fs-14 regular dorange">{{getLicences.length}} License(s) uploaded</td>
                                <td class="fs-14 regular dblue nowrap"><u (click)=" this.uploadnewLicensePopup = !this.uploadnewLicensePopup;openAddLicPopupAgency()" class="cp link">Add License
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">To add a new license, click "Add License" and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">Type</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen "><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                                
                            <td></td>
                        </tr> 
                        <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">Type</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtred"><u>Disapprove</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                                
                            <td></td>
                        </tr>  -->


                        </tbody>
                    </table>
                </div>

                <div class="clear20"></div>
                <label class="fbold fs-18 txt39">Void Cheque</label>
                <div class="table-responsive">
                    <table class="table bg-white">
                        <thead class="nowrap child-styling">
                            <tr>



                                <th class="semi-bold fs-14 text46 w150">Document Name</th>
                                <!-- <th class="semi-bold fs-14 text46">Document type</th> -->
                                <th class="semi-bold fs-14 text46 w150">Status</th>
                                <th class="semi-bold fs-14 text46 w150">Action
                                    <label class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 ">To update a file, click the icon below and follow the instructions.</span>
                                        </div>   
                                        </label>
                                </th>
                                <th class="semi-bold fs-14 text46 w150"></th>
                                <!-- <th class="semi-bold fs-14 text46">Expired Date</th> -->
                                <th class="semi-bold fs-14 text46 w150"></th>
                                <!-- <th></th>  -->
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getVoidCheck; let i=index">
                                <!-- <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel">{{item.documentName}}</label> </td> -->
                                <td>
                                    <!-- <img src="./assets/images/pdf.png">&nbsp;&nbsp; -->
                                    <label class="lightblue fs-14 regular cp" (click)="onClickOTPValidation(item)">{{item.documentName}}</label>
                                    <!-- <button type="button" class="fs-12 mr-2  btn bluebtn float-left" (click)="downloadEODocuments(getDocuments[i].fileDownloadUrl, getDocuments[i].documentName)"></button> -->

                                </td>
                                <td class="fs-14 regular dgrey" [ngClass]="{'expired': item.isExpired==true}">{{item.status}}
                                    <label class="tooltip1 mb-0" *ngIf="item.status == 'Proceed Pending'"><img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                            <span class="whitespacenormal italic tooltiptext2 fw600">"Proceed Pending" - the broker must press "Proceed" to apply the changes.</span>
                                        </div>   
                                        </label>
                                </td>
                                <td><label class="fs-14 regular"><img class="cp" (click)="onClickOTPValidation1(item);overwriteVoid(item);bankInfoPop('Confirm'); removeFields();uploadEno1Void(item,i);" title="Update" src="./assets/images/update.png"></label></td>
                                <!-- <td class="fs-14 regular dgrey">{{item.type}}</td> -->
                                <td class="fs-14 regular dgrey"></td>
                                <td class="fs-14 regular dgrey"></td>
                                <td class="fs-14 regular dgrey"></td>
                                <!-- <td class="fs-14 regular dgrey">{{item.expiryDate | date:'MM-dd-yyyy'}}</td> -->
                                <!-- <td class="fs-14 regular dblue" ><u class="cp" (click)="this.pdfmodel = !this.pdfmodel; onSelected(item.documentName,item.id,item.description)">Approved / Disapprove</u></td>          -->
                                
                                <!-- <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                               -->
                                <!-- <td class="fs-14 regular dorange"><u class="cp">More Info Req</u></td>                               -->
                                <td></td>
                            </tr>
                            <tr *ngIf="getVoidCheck.length==0">
                                <td class="fs-14 regular dorange">No Document available</td>
                                <td *ngIf="getVoidCheck.length<1" class="fs-14 regular dblue"><u class="cp link" (click)=" addFieldValuecheque();bankInfoPop('Save');this.uploadVoidChequePopup = !this.uploadVoidChequePopup;">Add Void Cheque</u></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <!-- <tr>                                
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)="this.pdfmodel = !this.pdfmodel;">p159.pdf</label> </td>
                            <td class="fs-14 regular dgrey">10/09/2020</td>
                            <td class="fs-14 regular dgrey">20/09/2021</td>
                            <td class="fs-14 regular txtgreen" ><u>Approved</u></td>         
                            <td class="fs-14 regular dorange"><u class="cp" (click)="this.moreInfo = !this.moreInfo;">More Info Req</u></td>                              
                         
                        </tr>  -->

                        </tbody>
                    </table>
                </div>
            </div>
            </div>
        </div>
        <div class="{{tabs[2].tabcontent}}" *ngIf="tabs[2].active">
            <div class="row greystrip">
                <div class="col-sm-12 col-md-12 col-lg-12 col-12">
                    <h5 class="semi-bold text46 pl-2 mt-1">Submitted Agreement</h5>
                </div>

            </div>
            <div class="clear20"></div>
            <!-- <label class="fbold fs-18 txt39">E & O</label> -->
            <div id="submitAgreementTable" class="table-responsive">
                <table class="table bg-white">
                    <thead>
                        <tr>
                            <th class="semi-bold fs-14 text46">Document Name</th>
                            <th class="semi-bold fs-14 text46">Created On</th>
                            <!-- <th class="semi-bold fs-14 text46">Signed On</th> -->
                            <!-- <th class="semi-bold fs-14 text46">Expired On</th>  -->
                            <th class="semi-bold fs-14 text46">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr>
                            <td><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label class="lightblue fs-14 regular cp" (click)=" this.pdfmodel2 = !this.pdfmodel2; onInfo(item)">{{item.name}}</label> </td>

                            <td class="fs-14 regular dgrey">{{contractCreatedDate}}</td>
                            <td class="fs-14 regular dgrey">{{contractExpireDate }}</td>
                            <td class="fs-14 regular dgrey">{{compStatus}}</td>
                            <td class="fs-14 regular dgrey">{{brokerStatus}}</td>

                            <td class="fs-14 regular dorange"><u class="cp" (click)="onContractInfo(item.id,leadStatusAgreement)">{{leadStatusAgreement}}- {{lastUpdatedDate}}</u></td>
                        </tr> -->
                        <tr *ngFor="let item of contractDetails">
                            <td *ngFor="let data of item.files"><img src="./assets/images/pdf.png">&nbsp;&nbsp;<label (click)=" this.deleteModal4 = !this.deleteModal4; onInfo(item)" class="lightblue fs-14 regular cp">{{data.name}}</label></td>

                            <td class="fs-14 regular dgrey">{{item.created | date:'dd-MM-yyyy'}}</td>
                            <!-- <td class="fs-14 regular dgrey">{{item.expires | date:'dd-MM-yyyy'}}</td> -->
                            <td class="fs-14 regular dgrey">{{item.status}}</td>

                        </tr>


                    </tbody>
                </table>
            </div>

        </div>
        <!-- <div class="{{tabs[3].tabcontent}}" *ngIf="tabs[3].active">
            <div class="row ">
                <div class="col-sm-12 col-md-12 col-lg-12 col-12">
                    <h5 class="semi-bold fs-23 text43">Convert</h5>
                    <div class="clear20"></div>
                    <p class="fs-16 regular txt39">You’ll be able to Create Agent code once the required<br/> onboarding steps are completed by the lead.</p>
                    <div class="clear20"></div>

                    <button type="button" class="btn btn-create" (click)="this.agentCode = !this.agentCode;">Create Agent Code</button>

                </div>
            </div>
        </div> -->
    </div>
</div>


<div id="deletemdl" class="modal" [style.display]="deleteModal ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg iframe">
        <div class="modal-content w-100">
            <div class="modal-header">
                <h6 class="close text-right cp" (click)="closeiframe(); this.deleteModal = !this.deleteModal;">&times;</h6>
            </div>
            <div class="modal-body p-0 m-0">
                <!-- <div class="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto text-center"> -->
                <iframe [src]='Url | sanitizePipe' height="500px" width="100%" title="Iframe Example"></iframe>
                <!-- </div> -->
            </div>
        </div>
    </div>
    <div class="clear20"></div>
</div>

<div id="deletemdl2" class="modal" [style.display]="deleteModal2 ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg iframe">
        <div class="modal-content w-100">
            <div class="modal-header">
                <h6 class="close text-right cp" (click)=" this.deleteModal2 = !this.deleteModal2;">&times;</h6>
            </div>
            <div class="modal-body p-0 m-0">
                <!-- <div class="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto text-center">
               
                </div> -->
                <iframe [src]='licensPreview | sanitizePipe' height="500px" width="100%" title="Iframe Example"></iframe>
            </div>
        </div>
    </div>
    <div class="clear20"></div>
</div>
<div id="deletemdl3" class="modal" [style.display]="deleteModal3 ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg iframe">
        <div class="modal-content w-100">
            <div class="modal-header">
                <h6 class="close text-right cp" (click)=" this.deleteModal3 = !this.deleteModal3;">&times;</h6>
            </div>
            <div class="modal-body p-0 m-0">
                <!-- <div class="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto text-center">
               
                </div> -->
                <iframe [src]='voidPreview | sanitizePipe' height="500px" width="100%" title="Iframe Example"></iframe>
            </div>
        </div>
    </div>
    <div class="clear20"></div>
</div>
<div id="deletemdl4" class="modal" [style.display]="deleteModal4 ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg iframe">
        <div class="modal-content w-100">
            <div class="modal-header">
                <h6 class="close text-right cp" (click)=" this.deleteModal4 = !this.deleteModal4;">&times;</h6>
            </div>
            <div class="modal-body p-0 m-0">
                <!-- <div class="col-12 col-sm-12 col-md-9 col-lg-9 mx-auto text-center">
               
                </div> -->

                <iframe [src]='urlSafe | sanitizePipe' height="500px" width="100%" title="Iframe Example"></iframe>
            </div>
        </div>
    </div>
    <div class="clear20"></div>
</div>
<div id="pdfmodelMisc" class="modal" [style.display]="pdfmodelMisc ? 'block' : 'none'">
    <div class="modal-dialog modal-lg iframe">
        <div class="modal-content" style="height:640px;">
            <div class="row px-3 pt-3">
                <div class="col-lg-10 col-sm-10 col-md-10 col-10">
                    &nbsp;<label class="lightblue regular fs-14">{{selectedFileName}}</label>
                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 col-2">
                    <h6 class="close1 text-right cp" (click)=" this.pdfmodelMisc = !this.pdfmodelMisc;">&times;</h6>
                </div>
            </div>
            <div class="modal-body">
                <div class="pdfarea">
                    <iframe [src]='UrlMisc | sanitizePipe' height="550px" width="100%" title="Iframe Example"></iframe>
                </div>
                <div class="clear20"></div>
                <!-- <div class="row">
                   <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                    <button  type="button" class="btn disappbtn mr-3" (click)=" this.pdfmodel = !this.pdfmodel;this.disapprovedmsg = !this.disapprovedmsg;">Disapprove</button>
                    <button type="button" class="btn apprbtn" (click)=" this.pdfmodel = !this.pdfmodel; onApprove()">Approve</button>                       
                   </div>
                   <div class="clear10"></div>
                 </div> -->
            </div>

        </div>
    </div>
    <div class="clear20"></div>
</div>
<div id="deleteLeadsPopup" class="modal" *ngFor="let uploadlic of uploadlicenseArray;let i=index; let last = last" [style.display]="uploadnewLicensePopup ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <h6 class="fs-18 txt-black regular">Upload License on Broker’s behalf.<span class="close1 float-right" (click)=" this.uploadnewLicensePopup = !this.uploadnewLicensePopup;">&times;</span></h6>
                <div class="clear10"></div>
                <p class="regular fs-14 txt-grey1">Please select .pdf, .png, .jpeg or .docx file only</p>
                <!-- <div class="row">
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12 pr-2"></div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Select province<span class="txt-red1 fs-18">*</span></label>
                    </div>
                </div> -->
                <div class="clear20"></div>
                <div class="row">
                    <div class="col-sm-8 col-md-8 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Choose File</label>
                        <div class="uploadfile">
                            <input type="file" [(ngModel)]="uploadlic.filelicens" (change)="FileSelectLic($event,i)">
                            <button type="button" class="btn file-btn">Choose File</button>
                        </div>
                        <span class="error-msg red fs-14">
                            </span>
                        <label class="fs-16 normal" [ngClass]="uploadlic.showemailErrorMsgone ?'red':''">{{fileenoNameLic}}</label>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <div class="form-group">
                            <!-- <select class="form-control selectinput mt-2" [(ngModel)]="uploadlic.province">
                                    <option selected disabled>Select province</option>
                                    <option disabled hidden value="undefined">Select province</option>
                                    <option *ngFor="let item of provienceList" [value]="item.provinceCode">
                                        {{item.provinceName}}- {{item.provinceCode}}</option>
                                </select> -->
                            <!-- <span class="error-msg red fs-14" *ngIf="showlicpErrorMsgone"></span> -->
                            <label class="fs-14 regular">Province</label>
                            <ng-select [(ngModel)]="uploadlic.province" placeholder="Add province">
                                <!-- <option selected disabled>Select province</option> -->
                                <!-- <option disabled hidden value="undefined">Select province</option> -->
                                <ng-option *ngFor="let item of provinceArray" [value]="item.provinceCode">
                                    {{item.provinceName}}- {{item.provinceCode}}</ng-option>
                            </ng-select>
                            <span class="error-msg red fs-14" *ngIf="showlicpErrorMsgone">
                            </span>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <div class="" *ngIf="agencyCallEO == true">
                            <!-- <select class="form-control selectinput mt-2" [(ngModel)]="uploadlic.province">
                                    <option selected disabled>Select province</option>
                                    <option disabled hidden value="undefined">Select province</option>
                                    <option *ngFor="let item of provienceList" [value]="item.provinceCode">
                                        {{item.provinceName}}- {{item.provinceCode}}</option>
                                </select> -->
                            <!-- <span class="error-msg red fs-14" *ngIf="showlicpErrorMsgone"></span> -->
                            <label class="fs-14 regular">License Type</label>
                            <ng-select [(ngModel)]="uploadlic.licencesType" placeholder="License Type">
                                <!-- <option selected disabled>Select province</option> -->
                                <!-- <option disabled hidden value="undefined">Select province</option> -->
                                <ng-option *ngFor="let item of corporateLicType" [value]="item">
                                    {{item}}</ng-option>
                            </ng-select>
                            <span class="error-msg red fs-14" *ngIf="showlicpErrorMsgone">
                            </span>
                        </div>
                        <div class=""  *ngIf="agencyCallEO == false">
                            <!-- <select class="form-control selectinput mt-2" [(ngModel)]="uploadlic.province">
                                    <option selected disabled>Select province</option>
                                    <option disabled hidden value="undefined">Select province</option>
                                    <option *ngFor="let item of provienceList" [value]="item.provinceCode">
                                        {{item.provinceName}}- {{item.provinceCode}}</option>
                                </select> -->
                            <!-- <span class="error-msg red fs-14" *ngIf="showlicpErrorMsgone"></span> -->
                            <label class="fs-14 regular">License Type</label>
                            <ng-select [(ngModel)]="uploadlic.licencesType" placeholder="License Type">
                                <!-- <option selected disabled>Select province</option> -->
                                <!-- <option disabled hidden value="undefined">Select province</option> -->
                                <ng-option *ngFor="let item of individualLicType" [value]="item">
                                    {{item}}</ng-option>
                            </ng-select>
                            <span class="error-msg red fs-14" *ngIf="showlicpErrorMsgone">
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <!-- <label class="fs-14 regular">License Number<span class="txt-red1 fs-18">*</span></label> -->
                        <div class="form-group ">
                            <label class="fs-14 regular">License Number</label>
                            <input type="text" [(ngModel)]="uploadlic.licenseNumber" class="form-control forminput h33" placeholder="Enter License Number" maxlength="30">
                        </div>
                        <span class="error-msg red fs-14" *ngIf="uploadlic.showlicnErrorMsgone">
                        </span>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Effective Date</label>
                        <mat-form-field class="forminput inputstyle h33">
                            <input matInput [matDatepicker]="picker1"  [max]="uploadlic.expiryDate" [(ngModel)]="uploadlic.effectiveDate">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1 ></mat-datepicker>
                          </mat-form-field>
                          
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Expiry Date</label>
                        
                        <mat-form-field class="forminput inputstyle h33">
                            <input matInput [matDatepicker]="picker2"  [min]="minDate" [(ngModel)]="uploadlic.expiryDate">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                          </mat-form-field>
                          
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <button type="button" class="btn btn-upload" (click)="uploadlicensefile(uploadlic,i)">Upload</button>
                    </div>
                </div>

                <!-- <button type="button" class="btn btn-link1 p-0" (click)="deleteFieldValue(i)">Remove</button> -->

                <!-- <button type="button" *ngIf="!isUploaddoc && !isCompleted" class="btn btn-add p-0" (click)="addFieldValue()">+Add More License</button> -->

            </div>
        </div>
    </div>
    <div class="clear20"></div>
</div>
<div id="deleteLeadsPopup" class="modal" [style.display]="uploadExpEOPopup ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <h6 class="fs-18 txt-black regular">Upload E&O on Broker’s behalf.<span class="close1 float-right" (click)=" this.uploadExpEOPopup = !this.uploadExpEOPopup;">&times;</span></h6>           
                <div class="clear10"></div>
                <p class="regular fs-14 txt-grey1">Please select .pdf, .png, .jpeg or .docx file only</p>
                <div class="clear20"></div>
                <div class="row">
                    <div class="col-sm-8 col-md-8 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Choose File</label>
                        <div class="uploadfile">
                            <input type="file" (change)="FileSelect($event)" maxFileSize="50000" [(ngModel)]="fileeno">
                            <button type="button" class="btn file-btn">Choose File</button>
                        </div>
                        <span class="error-msg red fs-14" *ngIf="showemailErrorMsg"></span>
                        <label class="fs-16 normal " [ngClass]="showemailErrorMsg ?'red':''">
                            {{fileenoName}}</label>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">Policy Number</label>
                            <!-- <input type="text" class="form-control forminput" placeholder="Enter E&O Number"> -->
                            <input type="text" class="form-control forminput w95" placeholder="E&O Policy Number" [(ngModel)]="policyNumber">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Effective Date</label>
                        <mat-form-field class="forminput inputstyle h33">
                            <input matInput [matDatepicker]="picker3"  [max]="expiryDate" [(ngModel)]="effectiveDate">
                            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                            <mat-datepicker #picker3 ></mat-datepicker>
                          </mat-form-field>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Expiry Date</label>
                        
                        <mat-form-field class="forminput inputstyle h33">
                            <input matInput [matDatepicker]="picker4"  [min]="minDate" [(ngModel)]="expiryDate">
                            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                            <mat-datepicker #picker4></mat-datepicker>
                          </mat-form-field>
                          <span class="error-msg red fs-14" *ngIf="showdateErrorMsg"></span>
                    </div>
                </div>
                <div class="clear20"></div>
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <button type="button" class="btn btn-upload" (click)="uploadEno();">Upload</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="deleteLeadsPopup" class="modal" *ngFor="let item of uploadvoidchequeArray;let i=index" [style.display]="uploadVoidChequePopup ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <h6 class="fs-18 txt-black regular">Upload Void Cheque on Broker’s behalf.</h6>
                <span class="close-icon1 float-right" (click)=" this.uploadVoidChequePopup = !this.uploadVoidChequePopup; removeBankInfoErrMsg();">&times;</span>
                <div class="clear5"></div>
                <p class="regular fs-14 txt-grey1">Please select .pdf, .png , .jpeg or .docx file only</p>
                    <div class="row">
                        <div class="col-sm-8 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                            <div class="uploadfile">
                                <input type="file" (change)="FileSelect1($event,i)" maxFileSize="50000" [(ngModel)]="item.fileeno1">
                                <button type="button" class="btn file-btn">Choose File</button><span class="txt-red1 fs-18">*</span>
                            </div>
                            <span class="error-msg red fs-14" *ngIf="item.showemailErrorMsg1">
                            </span>
                            <label class="fs-16 normal" [ngClass]="item.showemailErrorMsg1 ?'red':''">{{fileenoName1}}</label>

                        </div>
                        <div class="col-sm-1 col-md-5 col-lg-5 col-xl-5 col-12 pr-2"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                            <div class="form-group">
                                <label class="fs-14 regular">Bank Number (3 digits)<span class="txt-red1 fs-18">*</span></label>
                                <input type="text" class="form-control1 forminput w100 {{transitNoErrMsg?'border-red':''}}" placeholder="Bank Number" [(ngModel)]="transitNo" onkeydown="if(event.key==='.') {event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" (input)="transitNoErrMsgred()" maxlength="3">
                              
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                            <div class="form-group ">
                                <label class="fs-14 regular">Branch Number (5 digits)<span class="txt-red1 fs-18">*</span></label>
                                <input type="text" class="form-control1 forminput w100 {{financialInstitutionNoErrMsg?'border-red':''}}" placeholder="Branch  Number" [(ngModel)]="financialInstitutionNo" onkeydown="if(event.key==='.') {event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" (input)="financialInstitutionNoErrMsgred()" maxlength="5">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                            <div class="password-input">
                                <label class="fs-14 regular">Account Number (12 digits maximum):<span class="txt-red1 fs-18">*</span></label>
                                <input type="text" class="instyle regular  olnone form-control w100 {{accountNoErrMsg?'border-red':''}}" placeholder="Account Number" [(ngModel)]="accountNo" onkeydown="if(event.key==='.') {event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" (input)="checkAccountNumber()" maxlength="12">
                                <div class="clear5"></div>
                                <!-- <img src="./assets/images/eye.png" *ngIf="leadStatusStage == 'Activated'" class="cp password-img img-responsive cp" (click)="showAccountNumber('Account')"> -->
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                            <div class="password-input">
                                <label class="fs-14 regular">Confirm Account Number (12 digits maximum)<span class="txt-red1 fs-18">*</span></label>
                                <input type="text" class="instyle regular  olnone form-control w100 {{confirmaccountNoErrMsg?'border-red':''}}" placeholder="Confirm Account Number" [(ngModel)]="confirmaccountNo" onkeydown="if(event.key==='.') {event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" (input)="checkConfirmAccountNumber()" maxlength="12">
                                <div class="clear5"></div>
                                <!-- <img src="./assets/images/eye.png"  *ngIf="leadStatusStage == 'Activated'" class="cp password-img img-responsive cp" (click)="showAccountNumber('Confirm')"> -->
                                <!-- <img src="./assets/images/eye.png" *ngIf="leadStatusStage == 'Activated'" class="cp password-img img-responsive cp" (click)="showAccountNumber('Confirm')"> -->
                             </div>
                             <div>
                                <p class="fs-14 regular redstar" *ngIf="confirmAccountNumberMatch">Account No. and Confirm Account No. does not match.</p>
                                <p class="fs-14 regular redstar"  *ngIf="accountConfirmFlag">'Confirm Account Number' is required.</p>
                            </div>  
                        </div>
                    </div>
                    <div class="row">
                        <div class="checkbox1">
                            <input type="checkbox" [checked]="bankinfoChecked == true" value="true" (change)="onBankInfoSelected($event)">
                        </div>
                        <div class="col-11 col-sm-11 col-md-11 col-lg-11">
                            <label for="vehicle1" class="fs-14 regular black pl-1">“I acknowledge that I am uploading my banking information, as provided above, on {{ todayDate | date:'MM-dd-yyyy' }}.”</label>
                            <p class="dateSubtxt1 redstar" *ngIf="bankInfoErrmsg">To continue, read the above Information. If you agree, check the box beside.</p>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                            <div class="form-group">
                                <label class="fs-14 regular">Account Number (12 digits maximum)<span class="txt-red1 fs-18">*</span></label>
                                <input type="text" class="form-control forminput w95 {{accountNoErrMsg?'border-red':''}}" placeholder="Account Number" [(ngModel)]="accountNo" (input)="checkAccountNumber()" maxlength="12">
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                            <div class="form-group">
                                <label class="fs-14 regular">Confirm Account Number (12 digits maximum)<span class="txt-red1 fs-18">*</span></label>
                                <input type="text" class="form-control forminput w95 {{confirmaccountNoErrMsg?'border-red':''}}" placeholder="Confirm Account Number" [(ngModel)]="confirmaccountNo" (input)="checkConfirmAccountNumber()" maxlength="12">
                                <p class="fs-14 regular redstar" *ngIf="confirmAccountNumberMatch">Account No. and Confirm Account No. does not match.</p>
                                <p class="fs-14 regular redstar"  *ngIf="accountConfirmFlag">'Confirm Account Number' is required.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="checkbox1">
                            <input type="checkbox" [checked]="bankinfoChecked == true" value="true" (change)="onBankInfoSelected($event)">
                        </div>
                        <div class="col-11 col-sm-11 col-md-11 col-lg-11">
                            <label for="vehicle1" class="fs-14 regular black pl-1">“I acknowledge that I am changing my banking information, as provided above, on {{ todayDate | date:'MM-dd-yyyy' }}.”</label>
                            <p class="dateSubtxt1 redstar" *ngIf="bankInfoErrmsg">To continue, read the above Information. If you agree, check the box beside.</p>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 text-right">
                            <button type="button" class="btn btn-upload mr-2" (click)="cancelBtnPopup()">{{btncancelPopupName}}</button>
                            <button type="button" class="btn btn-upload" (click)="uploadEno1(item,i);">{{btnPopupName}}</button>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>
<!-- <div id="BankInfo" class="modal" [style.display]="BankInfo ? 'block' : 'none'">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <h6 class="fs-18 txt-black regular">{{popupName}} Banking Information<span class="close1 float-right cp" (click)="closeBankInfoPopup()">&times;</span></h6>           
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group">
                            <label class="fs-14 regular">Bank Number<span class="txt-red1 fs-18">*</span></label>
                            <input type="text" class="form-control forminput w95 {{transitNoErrMsg?'border-red':''}}" placeholder="Bank Number" [(ngModel)]="transitNo" (input)="transitNoErrMsgred()" maxlength="3">
                          
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">Branch  Number<span class="txt-red1 fs-18">*</span></label>
                            <input type="text" class="form-control forminput w95 {{financialInstitutionNoErrMsg?'border-red':''}}" placeholder="Branch  Number" [(ngModel)]="financialInstitutionNo" (input)="financialInstitutionNoErrMsgred()" maxlength="5">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group">
                            <label class="fs-14 regular">Account Number <span class="txt-red1 fs-18">*</span></label>
                            <input type="text" class="form-control forminput w95 {{accountNoErrMsg?'border-red':''}}" placeholder="Account Number" [(ngModel)]="accountNo" (input)="checkAccountNumber()" maxlength="12">
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group">
                            <label class="fs-14 regular">Confirm Account Number<span class="txt-red1 fs-18">*</span></label>
                            <input type="text" class="form-control forminput w95 {{confirmaccountNoErrMsg?'border-red':''}}" placeholder="Confirm Account Number" [(ngModel)]="confirmaccountNo" (input)="checkConfirmAccountNumber()" maxlength="12">
                            <p class="fs-14 regular redstar" *ngIf="confirmAccountNumberMatch">Account No. and Confirm Account No. does not match.</p>
                            <p class="fs-14 regular redstar"  *ngIf="accountConfirmFlag">'Confirm Account Number' is required.</p>
                        </div>
                    </div>
                </div>
                <div class=""></div>
                <div class="row">
                    <div class="checkbox1">
                        <input type="checkbox" [checked]="bankinfoChecked == true" value="true" (change)="onBankInfoSelected($event)">
                    </div>
                    <div class="col-11 col-sm-11 col-md-11 col-lg-11">
                        <label for="vehicle1" class="fs-14 regular black pl-1">“I acknowledge that I am changing my banking information, as provided above, on {{ todayDate | date:'MM-dd-yyyy' }}.”</label>
                        <p class="dateSubtxt1 redstar" *ngIf="bankInfoErrmsg">To continue, read the ‘Declaration’ above. If you agree, check the box beside the insured(s).</p>
                    </div>
                </div>
                <div class=""></div>
                <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                        
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 text-right">
                        <button type="button" class="btn btn-upload mr-2" *ngIf="this.btnPopupName == 'Confirm'" (click)="cancelBtnPopup()">{{btncancelPopupName}}</button>
                        <button type="button" class="btn btn-upload" (click)="uploadEno1(voidIndexitem,indexno);">{{btnPopupName}}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- end banking info -->
<!-- edit banking info -->
<!-- <div id="EditBankInfo" class="modal" [style.display]="EditBankInfo ? 'block' : 'none'">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <h6 class="fs-18 txt-black regular p-2">Banking Information<span class="close1 float-right cp" (click)=" this.EditBankInfo = !this.EditBankInfo;">&times;</span></h6> 
                <div class="clear10"></div>
                <span class="edit-icon1 float-right cp" (click)="editBankInfo()"><img src="./assets/images/pencilicon.png" class="img-edit">Edit</span> 
                <div class="whitebg radius_3 document_box box-shadow">
                    <table class="document fontsize15px">
                        <tbody>
                        <tr>
                            <td class="p-2">Bank Number :</td>
                            <td>{{transitNo}}</td>
                        </tr>
                        <tr>
                            <td class="p-2">Branch Number :</td>
                            <td>{{financialInstitutionNo}}</td>
                        </tr>
                        <tr>
                            <td class="p-2">Account Number :</td>
                            <td>{{accountNo}}</td>
                        </tr>
                    </tbody>
                   </table>
                </div>
                <button type="button" class="btn btn-close" (click)="this.EditBankInfo =! this.EditBankInfo;">Close</button>
            </div>
        </div>
    </div>
</div> -->
<!-- void cheque update otp verification -->
<div id="moreinfo" class="modal" [style.display]="updateVoidChequeotpVerificationPopup ? 'block' : 'none'">
    <div class="modal-dialog1 modal-md">
        <div class="modal-content1">
            <div class="pl-3 pt-3 pr-3">
                <h5 class="semi-bold text-center txtlightblack1 mt-2">Verification Code Required</h5>
                <h6 class="close3 float-right" (click)=" this.updateVoidChequeotpVerificationPopup = !this.updateVoidChequeotpVerificationPopup">&times;</h6>
            </div>
            <div class="modal-body pt-0">
                <label class="regularfs-16 txtlightblack1 text-center">A verification code has been sent to your registered email address. If you do not see the email in your inbox, please check your spam or junk folders. This code will expire in 5 minutes.</label>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 text-center">
                        <div class="form-group">
                            <input type="tel"  pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==6) return false;" autofocus class="otpInputBox" [(ngModel)]="otpOfVoidCheque" maxlength="6"> 
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <label class="fs-14 txtgrey1 red">Code expires in: {{ otpTimerDisplaySIN }}</label>
                   </div>
                   <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <label class="cp link fs-14 regular"  *ngIf="isOtpExpiredSIN"><u (click)="resendVoidChequeOTP1()">Resend Verification Code</u></label>
                    </div>
                </div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 text-center">
                        <button type="button"  class="btn btn-verify" [disabled]="isOtpExpiredSIN" (keydown)="onEnterKeyPressedForVoidCheque($event)" (click)="verifyOTP1()">Verify</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End void cheque update otp verification -->
<!-- otp verification for document -->
<div id="moreinfo" class="modal" [style.display]="otpVerificationPopup ? 'block' : 'none'">
    <div class="modal-dialog1 modal-md">
        <div class="modal-content1">
            <div class="pl-3 pt-3 pr-3">
                <h5 class="semi-bold text-center txtlightblack1 mt-2">Verification Code Required</h5>
                <h6 class="close3 float-right" (click)=" this.otpVerificationPopup = !this.otpVerificationPopup">&times;</h6>
            </div>
            <div class="modal-body pt-0">
                <label class="regularfs-16 txtlightblack1 text-center">A verification code has been sent to your registered email address. If you do not see the email in your inbox, please check your spam or junk folders. This code will expire in 5 minutes.</label>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 text-center">
                        <div class="form-group">
                            <!-- <input type="number"  pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==6) return false;" autofocus class="otpInputBox" [(ngModel)]="otpOfVoidCheque" maxlength="6">  -->
                            <input type="tel"  pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==6) return false;" autofocus class="otpInputBox" [(ngModel)]="otpOfVoidCheque" maxlength="6"> 
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <label class="fs-14 txtgrey1 red">Code expires in: {{ otpTimerDisplaySIN }}</label>
                   </div>
                   <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <label class="cp link fs-14 regular" *ngIf="isOtpExpiredSIN"><u (click)="resendVoidChequeOTP()">Resend Verification Code</u></label>
                    </div>
                </div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 text-center">
                        <!-- <button type="button"  class="btn btn-verify" (click)="verifyOTP()">Verify</button> -->
                        <button type="button"  class="btn btn-verify" [disabled]="isOtpExpiredSIN" (keydown)="onEnterKeyPressed($event)" (click)="verifyOTP()">Verify</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- End  otp verification for popup-->
